// --- GESTION DU PANIER TIROIR & AJAX SHOPIFY ---

const cartOverlay = document.getElementById('cartOverlay');
const cartDrawer = document.getElementById('cartDrawer');

function openCart() {
    if(cartOverlay) cartOverlay.classList.add('active');
    if(cartDrawer) cartDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeCart() {
    if(cartOverlay) cartOverlay.classList.remove('active');
    if(cartDrawer) cartDrawer.classList.remove('active');
    document.body.style.overflow = 'auto';
}

// Ajouter un produit via l'API Ajax de Shopify
function addVariantToCart(variantId) {
    let formData = {
        'items': [{
            'id': variantId,
            'quantity': 1
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        updateCartDrawerUI();
        openCart();
    })
    .catch((error) => {
        console.error('Erreur lors de l\'ajout au panier :', error);
    });
}

// Mettre à jour dynamiquement le contenu du tiroir panier
function updateCartDrawerUI() {
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
        const navCartCount = document.getElementById('nav-cart-count');
        if(navCartCount) navCartCount.textContent = cart.item_count;

        const cartBody = document.getElementById('cartBody');
        const cartTotalPrice = document.getElementById('cartTotalPrice');
        
        if(cartTotalPrice) {
            cartTotalPrice.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
        }

        if(cartBody) {
            if (cart.items.length === 0) {
                cartBody.innerHTML = `<div class="empty-cart-msg">Votre panier est actuellement vide.</div>`;
            } else {
                let html = '';
                cart.items.forEach(item => {
                    html += `
                        <div class="cart-item">
                            <img src="${item.image ? item.image : ''}" class="cart-item-img" alt="${item.product_title}">
                            <div class="cart-item-details">
                                <div class="cart-item-title">${item.product_title}</div>
                                <div class="cart-item-price">${(item.final_price / 100).toFixed(2).replace('.', ',')} €</div>
                                <div class="qty-selector">
                                    <button class="qty-btn" onclick="changeItemQty('${item.key}', ${item.quantity - 1})">-</button>
                                    <span class="qty-val">${item.quantity}</span>
                                    <button class="qty-btn" onclick="changeItemQty('${item.key}', ${item.quantity + 1})">+</button>
                                </div>
                            </div>
                        </div>
                    `;
                });
                cartBody.innerHTML = html;
            }
        }
    });
}

function changeItemQty(itemKey, newQty) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: newQty })
    })
    .then(response => response.json())
    .then(cart => {
        updateCartDrawerUI();
    });
}

// Charger l'état du panier au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    updateCartDrawerUI();
});


// --- SCRIPT THREE.JS ---

const container = document.getElementById('canvas-container');

if (container) {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(45, container.clientWidth / container.clientHeight, 0.1, 100);
    camera.position.set(0, 0, 4.5);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(container.clientWidth, container.clientHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    container.appendChild(renderer.domElement);

    const controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    controls.enableZoom = false; 
    controls.enablePan = false;

    const ambientLight = new THREE.AmbientLight(0xffffff, 1.2);
    scene.add(ambientLight);

    const dirLight1 = new THREE.DirectionalLight(0xffffff, 1.5);
    dirLight1.position.set(5, 5, 3);
    scene.add(dirLight1);

    const dirLight2 = new THREE.DirectionalLight(0xE6DCD0, 1);
    dirLight2.position.set(-5, -2, 2);
    scene.add(dirLight2);

    const hydrogelMaterial = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        transmission: 0.2,
        opacity: 1,
        transparent: true,
        roughness: 0.08,
        ior: 0,
        clearcoat: 1.0,
        clearcoatRoughness: 0.1,
        side: THREE.DoubleSide
    });

    let maskObj;
    const loader = new THREE.GLTFLoader();
    
    setTimeout(() => {
        const loaderEl = document.getElementById('loader');
        if (loaderEl && loaderEl.style.display !== 'none') {
            loaderEl.style.opacity = '0';
            setTimeout(() => loaderEl.style.display = 'none', 600);
        }
    }, 4000);

    // Utilisation sécurisée de l'URL du fichier GLB générée par Shopify
    loader.load(window.biodanceGlbUrl, 
        (gltf) => {
            maskObj = gltf.scene; 
            
            maskObj.traverse((child) => {
                if (child.isMesh) {
                    child.material = hydrogelMaterial; 
                }
            });

            const box = new THREE.Box3().setFromObject(maskObj);
            const center = box.getCenter(new THREE.Vector3());
            const size = box.getSize(new THREE.Vector3());
            
            const scale = (window.innerWidth < 900 ? 1.5 : 2.2) / Math.max(size.x, size.y, size.z);
            maskObj.scale.setScalar(scale);
            maskObj.position.sub(center.multiplyScalar(scale));

            scene.add(maskObj);
            
            const loaderEl = document.getElementById('loader');
            if (loaderEl) {
                loaderEl.style.opacity = '0';
                setTimeout(() => loaderEl.style.display = 'none', 600);
            }
        },
        undefined, 
        (error) => {
            const loaderEl = document.getElementById('loader');
            if (loaderEl) {
                loaderEl.style.opacity = '0';
                setTimeout(() => loaderEl.style.display = 'none', 600);
            }
            console.error("Impossible de charger le masque .glb :", error);
        }
    );

    const clock = new THREE.Clock();

    function animate() {
        requestAnimationFrame(animate);
        
        if (maskObj && !controls.state) {
            const time = clock.getElapsedTime();
            maskObj.rotation.y += 0.003;
            maskObj.position.y = Math.sin(time * 1.5) * 0.05; 
        }
        
        controls.update();
        renderer.render(scene, camera);
    }
    animate();

    window.addEventListener('resize', () => {
        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.clientWidth, container.clientHeight);
    });
}